import { useEffect, useState } from 'react';
import _ from 'lodash';
import { useDispatch } from 'react-redux';
import { getMeta, viewDocument } from 'services/document-services';
import Typography from '@mui/material/Typography';
import Alert from '@mui/material/Alert';
import AlertTitle from '@mui/material/AlertTitle';
import LinearProgress from '@mui/material/LinearProgress';
import { useLocation } from 'react-router-dom';
import { toggleLoader } from 'state/reducers/common-actions';

const MoM = () => {
  const [isLoading, setLoading] = useState(false);
  const [momPDF, setMoMPDF] = useState<any>();
  const { state } = useLocation();
  const dispatch = useDispatch();
  useEffect(() => {
    async function fetchData() {
      const data = await getMeta(state?.loanRequestId, 'MOM', 'LOAN_REQUEST');
      if (data?.id) {
        const momFile = await viewDocument(data?.id);
        const file = new File([momFile], `MoM_${state?.loanRequestId}`, {
          type: 'application/pdf',
        });
        const url = window.URL.createObjectURL(file);
        data && setMoMPDF(`${url}#view=FitH`);
      }
      dispatch(toggleLoader(false));
      setLoading(false);
    }
    setLoading(true);
    dispatch(toggleLoader(true));
    fetchData();
  }, [state?.loanRequestId]);

  return (
    <div style={{ alignItems: 'center' }}>
      {momPDF && (
        <>
          <object data={momPDF} type="application/pdf" style={{ width: '100%', height: '100vh' }}>
            <Alert severity="warning" variant="outlined" sx={{ height: '100vh' }}>
              <AlertTitle>
                <Typography variant="h6">Warning</Typography>
              </AlertTitle>
              <Typography variant="subtitle1">
                Minute of Meeting is not yet created, please submit form.
              </Typography>
            </Alert>
          </object>
        </>
      )}
      {!isLoading && !momPDF && (
        <Alert severity="warning" variant="outlined" sx={{ height: '100vh' }}>
          <AlertTitle>
            <Typography variant="h6">Warning</Typography>
          </AlertTitle>
          <Typography variant="subtitle1">Minute of Meeting is not yet created, please submit form.</Typography>
        </Alert>
      )}
      {isLoading && (
        <Alert
          severity="info"
          variant="outlined"
          sx={{ height: '100vh', '& .MuiAlert-message': { width: '100%' } }}>
          <AlertTitle>
            <LinearProgress color="inherit" />
          </AlertTitle>
          <Typography variant="subtitle1">Please wait while Minute of Meeting get loaded</Typography>
        </Alert>
      )}
    </div>
  );
};

export default MoM;
